import { CancelButton, EditButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { TextLabel } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid } from '@material-ui/core';
import React, { useContext } from 'react';
import { FaCreditCard } from 'react-icons/fa';
import { ContaContext } from '../../../ContaContext';
import { modaisConta } from '../modais';
import { contaModalStyles } from '../modalStyles';

const getDigitosCartao = (digitos) => {
  if (typeof digitos === 'number' && digitos !== 0) {
    return `${digitos}`.padStart(4, '0');
  }
  return digitos;
};

const VisualizarContaCartaoModal = () => {
  const [modal, setModal] = useContext(ContaContext).modal;
  const [conta] = useContext(ContaContext).contaAtual;
  const [contasCorrente] = useContext(ContaContext).contasCorrente;
  const [bancos] = useContext(ContaContext).bancos;

  const modalStyles = contaModalStyles();

  const getBanco = (bancoId) => {
    if (!bancoId) {
      return false;
    }
    const [banco] = bancos.filter((b) => b.id === bancoId);

    return `${banco?.codigo ? `${banco?.codigo} - ` : ''}${banco?.nome}`;
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenEditMode = () => {
    setModal(modaisConta.editarContaCartao);
  };

  const [contaPadraoPagamento = {}] = contasCorrente.filter((c) => c.id === conta?.contaCartao?.contaPadraoPagamentoId);

  const Content = () => {
    return (
      <div className={modalStyles.container}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="descricao" label="Descrição" value={conta?.descricao} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="digitos"
              label="Últimos 4 dígitos do cartão"
              value={getDigitosCartao(conta?.contaCartao?.digitosCartao)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="emissor" label="Emissor do cartão" value={getBanco(conta?.contaCartao?.emissorId)} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="contaPadrao" label="Conta padrão para pagamento" value={contaPadraoPagamento.descricao} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="diaFechamento" label="Dia do fechamento" value={conta?.contaCartao?.diaFechamento} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="diaVencimento" label="Dia do vencimento" value={conta?.contaCartao?.diaVencimento} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="bandeira" label="Bandeira" value={conta?.contaCartao?.bandeira} />
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <SimpleDialog open={modal === modaisConta.visualizarContaCartao} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de cartão de crédito',
          icon: <FaCreditCard />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              {permissaoUtils.conta().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarContaCartaoModal;
